export default __webpack_public_path__ + "static/media/back_light.c0d371b8.svg";